import {Component, Inject} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {UppercaseNoAccentDirective} from "@shared/directives/uppercase-no-accent.directive";
import {IDetalleReceta} from "@core/interfaces/receta-data";
import {PrescriptionService} from "@core/http/table-data-services/prescription.service";
import {HttpErrorResponse} from "@angular/common/http";
import {GeneralFunctionsService} from "@core/service/generalFunctions.service";
import Swal from "sweetalert2";
import {IReaccion} from "@core/models/Reaccion";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";

@Component({
  selector: 'app-my-prescription-reactions',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatIconButton,
    MatDialogContent,
    UppercaseNoAccentDirective,
  ],
  templateUrl: './my-prescription-reactions.component.html',
  styleUrl: './my-prescription-reactions.component.scss'
})
export class MyPrescriptionReactionsComponent {
  obs: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDetalleReceta,
    private prescriptionService: PrescriptionService,
    private gfs: GeneralFunctionsService,
    private dialogRef: MatDialogRef<MyPrescriptionReactionsComponent>,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    if (data && data.descripcion) {
      this.obs = data.descripcion;
    }
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    if (!this.obs) {
      Swal.fire({
        title: 'SE GUARDARA VACIO EL CAMPO, ¿CONTINUAR?',
        showCancelButton: true,
        confirmButtonText: 'SI',
        cancelButtonText: 'CANCELAR',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.processReaction();
        } else if (result.isDenied) {
        }
      })
    } else {
      this.processReaction();
    }
  }

  processReaction() {
    const reaccion: IReaccion = {
      descripcion: this.obs,
      idDetalleReceta: this.data.idDetalleReceta,
      idReceta: this.data.idReceta,
      medicamentoId: this.data.medicamentoId,
      medicamentoType: this.data.medicamentoType,
    }
    const cleanData = this.gfs.mayusAcentos(reaccion);
    this.prescriptionService.reaccionCrearActualizar(cleanData).subscribe({
      next: (res) => {
        const code = res.code || 'CODIGO NO DISPONIBLE';
        const message = res.message || 'DESCRIPCION DESCONOCIDA';

        Swal.fire({
          icon: 'success',
          title: `¡CORRECTO!`,
          text: message,
          footer: `CODIGO: (${code})`,
        }).then(() => this.dialogRef.close(1));
      },
      error: (error: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(error);
      },
    });
  }
}
